module.exports = __webpack_public_path__ + "media/unipod/icon-plumbing-2-white-ea4914f9.svg";